import A11yDialog from 'a11y-dialog'

document.addEventListener("DOMContentLoaded", () => {

	const videoEmbeds = document.querySelectorAll('[data-videoId')

	videoEmbeds.forEach(videoWrapper => {
		videoWrapper.querySelector('.wp-block-wf-youtube-gdpr__overlay').addEventListener('click', () => {
			checkForConsent(videoWrapper)
		})
	})
})


const checkForConsent = (videoWrapper) => {
	const cookie = getCookie()
	if(cookie) {
		showVideo(videoWrapper)
	} else {
		showConsentDialog(videoWrapper)
	}
}


const showConsentDialog = (videoWrapper) => {
	const container = videoWrapper.querySelector('#consent-dialog-'+videoWrapper.dataset.videoid)
	const dialog = new A11yDialog(container)

	dialog.on('show', () => {
		document.querySelector('body').style.overflow = 'hidden'
	})

	dialog.on('hide', () => {
		document.querySelector('body').style.overflow = ''
	})

	const btnConfirmConsent = videoWrapper.querySelector('#btn-confirm-consent-'+videoWrapper.dataset.videoid)
	btnConfirmConsent.addEventListener('click', () => {
		dialog.hide()
		showVideo(videoWrapper)
		setCookie()
	})

	const btnConfirmConsentOnce = videoWrapper.querySelector('#btn-confirm-consent-once-'+videoWrapper.dataset.videoid)
	btnConfirmConsentOnce.addEventListener('click', () => {
		dialog.hide()
		showVideo(videoWrapper)
	})

	const btnDenyConsent = videoWrapper.querySelector('#btn-deny-consent-'+videoWrapper.dataset.videoid)
	btnDenyConsent.addEventListener('click', () => {
		dialog.hide()
	})

	dialog.show()
}

// Embed video

const showVideo = (videoWrapper) => {

	const videoContainerElement = videoWrapper.querySelector('.wp-block-wf-youtube-gdpr__video-container')
	const videoElement = videoWrapper.querySelector('.wp-block-wf-youtube-gdpr__video')
	const previewImgElement = videoWrapper.querySelector('.wp-block-wf-youtube-gdpr__preview-img')

	const videoUrl = videoElement.dataset.src
	videoElement.setAttribute('src', videoUrl)
	videoElement.removeAttribute('data-src')

	videoContainerElement.classList.remove('wp-block-wf-youtube-gdpr__video--hidden')
	previewImgElement.classList.add('wp-block-wf-youtube-gdpr__video--hidden')

}


// Cookie helper functions

const getCookie = () => {
	const cookie = document.cookie.split("; ").find((row) => row.startsWith("youtube-consent="))?.split("=")[1]
	return cookie
}

const setCookie = () => {
	document.cookie = 'youtube-consent=confirmed; expires=3650; path=/'
}
